/**
 * Звонки: чем закончился и как двигается состояние.
 *
 * Источник правды о звонке — телефонная станция, а не действия диспетчера.
 * Дозвон определяется по ноге транка, а время разговора — по времени
 * в соединении, иначе в него попадают гудки (§7.4).
 */
/** Чем закончился звонок (§5.2, тип call_disposition в базе) */
/**
 * Значение `X-Assignment-Id` у служебного звонка — ручного набора без карточки (§7.3).
 *
 * Ручной набор ездит по тому же пути, что и обычный звонок: диалплан кладёт
 * заголовок в аргумент Stasis, телефония разбирает его первой же строкой.
 * Отдельный заголовок означал бы правку диалплана, вторую переменную канала и
 * второе поле в CDR — ради одного признака, который в существующее поле
 * помещается без двусмысленности: идентификаторы назначений — это bigint,
 * и совпасть со словом они не могут никогда.
 *
 * Меткой прав это НЕ является: пометить свой INVITE может любой софтфон,
 * поэтому телефония на StasisStart сама проверяет и номер, и часовой лимит.
 */
export const MANUAL_CALL_MARKER = 'manual';
export const CALL_DISPOSITIONS = [
    /** Поговорили */
    'answered',
    /** Не взяли трубку */
    'no_answer',
    /** Занято */
    'busy',
    /** Сброс абонентом */
    'rejected',
    /** Номер не существует или отключён */
    'invalid_number',
    /** Нет свободных линий у оператора */
    'congestion',
    /** Переадресация на голосовую почту: транк положен по SIP 181 до ответа */
    'voicemail',
    /** Вызов перехвачен антиспамом оператора */
    'antispam_blocked',
    /** Обрыв связи у диспетчера: в статистику источника не идёт */
    'network_error',
    /** Диспетчер отменил набор до ответа */
    'canceled_by_dispatcher',
    /** Звонок потерян: станция перезапустилась, итог восстановлен сверкой */
    'lost',
    /** Правило не подобралось — повод дополнить таблицу правил */
    'unknown',
];
/**
 * Состояния звонка по возрастанию (§7.4).
 *
 * Переход разрешён только вперёд по этому порядку либо в терминальное.
 * Порядок задаётся рангом, а не временем события: после переподключения
 * к станции и при сверке с историей события приходят вперемешку,
 * и опоздавшие гудки не должны откатывать уже отвеченный звонок.
 */
export const CALL_STATE_RANK = {
    created: 0,
    dialing: 1,
    ringing: 2,
    answered: 3,
};
export const TERMINAL_CALL_STATES = ['hangup', 'failed'];
export function isTerminalCallState(state) {
    return state === 'hangup' || state === 'failed';
}
/** Можно ли применить новое состояние поверх текущего */
export function canAdvanceCallState(from, to) {
    if (isTerminalCallState(from))
        return false;
    if (isTerminalCallState(to))
        return true;
    return CALL_STATE_RANK[to] > CALL_STATE_RANK[from];
}
//# sourceMappingURL=call.js.map